import { render, staticRenderFns } from "./ContentListItemLabel.vue?vue&type=template&id=490064e8&scoped=true&"
import script from "./ContentListItemLabel.vue?vue&type=script&lang=js&"
export * from "./ContentListItemLabel.vue?vue&type=script&lang=js&"
import style0 from "./ContentListItemLabel.vue?vue&type=style&index=0&id=490064e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490064e8",
  null
  
)

export default component.exports